import { apiGetReviews } from "Root/api/apiCheckout";
import { useState, useEffect } from "react";
const useReviewsData = () => {
    const [reviewsData, setReviewsData] = useState(null);
    const getReviews = async () => {
        const data = await apiGetReviews();
        if (data) {
            setReviewsData(data);
        }
    };
    useEffect(() => {
        getReviews();
    }, []);
    return reviewsData;
};
export default useReviewsData;
